/* eslint-disable jsx-a11y/media-has-caption */
import React, { useRef, useEffect, useState, useMemo, Fragment } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import classnames from 'classnames';
import { IconButton, Slider } from '@fluentui/react';
import { registerIcons } from '@fluentui/style-utilities';

import { getIconClass } from './styles';

registerIcons({
  icons: {
    videoPlayBig: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="black" xmlns="http://www.w3.org/2000/svg"><path d="M7.60846 4.61507C7.1087 4.34314 6.5 4.70491 6.5 5.27386V18.7262C6.5 19.2951 7.1087 19.6569 7.60846 19.385L19.97 12.6588C20.4921 12.3747 20.4921 11.6253 19.97 11.3412L7.60846 4.61507ZM5 5.27386C5 3.56701 6.82609 2.4817 8.32538 3.29749L20.687 10.0236C22.2531 10.8758 22.2531 13.1242 20.687 13.9764L8.32538 20.7025C6.82609 21.5183 5 20.433 5 18.7262V5.27386Z" /></svg>
    ),
    videoPause: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="black" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M3.99609 4.75C3.99609 3.7835 4.7796 3 5.74609 3H9.24609C10.2126 3 10.9961 3.7835 10.9961 4.75V19.25C10.9961 20.2165 10.2126 21 9.24609 21H5.74609C4.7796 21 3.99609 20.2165 3.99609 19.25V4.75ZM5.74609 4.5C5.60802 4.5 5.49609 4.61193 5.49609 4.75V19.25C5.49609 19.3881 5.60802 19.5 5.74609 19.5H9.24609C9.38416 19.5 9.49609 19.3881 9.49609 19.25V4.75C9.49609 4.61193 9.38416 4.5 9.24609 4.5H5.74609ZM12.9961 4.75C12.9961 3.7835 13.7796 3 14.7461 3H18.2461C19.2126 3 19.9961 3.7835 19.9961 4.75V19.25C19.9961 20.2165 19.2126 21 18.2461 21H14.7461C13.7796 21 12.9961 20.2165 12.9961 19.25V4.75ZM14.7461 4.5C14.608 4.5 14.4961 4.61193 14.4961 4.75V19.25C14.4961 19.3881 14.608 19.5 14.7461 19.5H18.2461C18.3842 19.5 18.4961 19.3881 18.4961 19.25V4.75C18.4961 4.61193 18.3842 4.5 18.2461 4.5H14.7461Z" /></svg>
    ),
    videoReplay: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="black" xmlns="http://www.w3.org/2000/svg"><path d="M12 4.5C16.1421 4.5 19.5 7.85786 19.5 12C19.5 16.1421 16.1421 19.5 12 19.5C7.85786 19.5 4.5 16.1421 4.5 12C4.5 11.6236 4.52772 11.2538 4.58123 10.8923C4.64845 10.4382 4.31609 10 3.85708 10C3.48623 10 3.161 10.2562 3.10471 10.6228C3.03576 11.0718 3 11.5317 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C9.69494 3 7.59227 3.86656 6 5.29168V4.25C6 3.83579 5.66421 3.5 5.25 3.5C4.83579 3.5 4.5 3.83579 4.5 4.25V7.25C4.5 7.66421 4.83579 8 5.25 8H8.25C8.66421 8 9 7.66421 9 7.25C9 6.83579 8.66421 6.5 8.25 6.5H6.90093C8.23907 5.25883 10.0309 4.5 12 4.5Z" /></svg>
    ),
    videoMute: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="black" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M2.21968 2.21966C2.51257 1.92677 2.98745 1.92678 3.28034 2.21968L21.7801 20.7198C22.073 21.0127 22.073 21.4876 21.7801 21.7805C21.4872 22.0734 21.0123 22.0734 20.7194 21.7805L15 16.0609V19.7456C15 20.8242 13.7255 21.3965 12.9194 20.6797L8.42793 16.686C8.29063 16.5639 8.11329 16.4965 7.92956 16.4965H4.25C3.00736 16.4965 2 15.4891 2 14.2465V9.74856C2 8.50592 3.00736 7.49856 4.25 7.49856H6.43782L2.21966 3.28032C1.92677 2.98743 1.92678 2.51255 2.21968 2.21966ZM13.5 19.1888V14.5609L7.93777 8.99855L7.92961 8.99856H4.25C3.83579 8.99856 3.5 9.33435 3.5 9.74856V14.2465C3.5 14.6607 3.83579 14.9965 4.25 14.9965H7.92956C8.48074 14.9965 9.01275 15.1988 9.42465 15.565L13.5 19.1888ZM13.4995 10.3177V4.8063L10.582 7.40015L9.51953 6.33766L12.919 3.31533C13.725 2.59866 14.9995 3.17089 14.9995 4.24951V11.8177L13.4995 10.3177ZM17.1412 13.9588L18.2792 15.0969C18.741 14.1624 19.0002 13.1103 19.0002 11.9996C19.0002 10.7964 18.696 9.66203 18.1598 8.67142C17.9626 8.30715 17.5074 8.17171 17.1432 8.36891C16.7789 8.5661 16.6434 9.02125 16.8406 9.38551C17.2611 10.1623 17.5002 11.0519 17.5002 11.9996C17.5002 12.6906 17.3731 13.3508 17.1412 13.9588ZM20.4811 17.2999L19.3877 16.2065C20.0954 14.9664 20.4996 13.5312 20.4996 12.0001C20.4996 10.1063 19.8811 8.35899 18.8349 6.94644C18.5884 6.61358 18.6583 6.14389 18.9912 5.89736C19.324 5.65082 19.7937 5.7208 20.0403 6.05365C21.2713 7.71573 21.9996 9.77393 21.9996 12.0001C21.9996 13.9458 21.4433 15.7632 20.4811 17.2999Z" /></svg>
    ),
    videoUnmute: (
      <svg width="22" height="22" viewBox="0 0 22 22" fill="black" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M13 2.25049C13 1.17187 11.7255 0.599636 10.9195 1.31632L6.42794 5.30958C6.29065 5.43165 6.11333 5.49908 5.92961 5.49908H2.25C1.00736 5.49908 0 6.50644 0 7.74908V12.247C0 13.4896 1.00736 14.497 2.25 14.497H5.92956C6.11329 14.497 6.29063 14.5644 6.42793 14.6865L10.9194 18.6802C11.7255 19.397 13 18.8248 13 17.7461V2.25049ZM7.4246 6.4306L11.5 2.80728V17.1893L7.42465 13.5656C7.01275 13.1993 6.48074 12.997 5.92956 12.997H2.25C1.83579 12.997 1.5 12.6612 1.5 12.247V7.74908C1.5 7.33486 1.83579 6.99908 2.25 6.99908H5.92961C6.48075 6.99908 7.01272 6.79679 7.4246 6.4306ZM16.9912 3.89736C17.324 3.65082 17.7937 3.7208 18.0403 4.05365C19.2713 5.71573 19.9996 7.77393 19.9996 10C19.9996 12.2261 19.2713 14.2843 18.0403 15.9464C17.7937 16.2793 17.324 16.3492 16.9912 16.1027C16.6583 15.8562 16.5884 15.3865 16.8349 15.0536C17.8811 13.6411 18.4996 11.8939 18.4996 10C18.4996 8.10623 17.8811 6.35899 16.8349 4.94644C16.5884 4.61359 16.6583 4.1439 16.9912 3.89736ZM16.1598 6.67142C15.9626 6.30715 15.5074 6.17172 15.1432 6.36891C14.7789 6.5661 14.6434 7.02125 14.8406 7.38551C15.2611 8.16228 15.5002 9.05188 15.5002 9.99958C15.5002 10.9473 15.2611 11.8369 14.8406 12.6137C14.6434 12.9779 14.7789 13.4331 15.1432 13.6303C15.5074 13.8275 15.9626 13.692 16.1598 13.3278C16.696 12.3372 17.0002 11.2028 17.0002 9.99958C17.0002 8.79638 16.696 7.66203 16.1598 6.67142Z" /></svg>
    ),
  },
});

function padTime(time) {
  return Math.floor(time).toString().padStart(2, '0');
}

function Time({ currentTime, duration }) {
  const durationString = `${padTime(duration / 60)}:${padTime(duration % 60)}`;
  const currentTimeString = `${padTime(currentTime / 60)}:${padTime(currentTime % 60)}`;
  const divider = ' / ';

  return (
    <div className="time">
      <span className="currentTime">{currentTimeString}</span>
      <span className="divider">{divider}</span>
      <span className="totalTime">{durationString}</span>
    </div>
  );
}

Time.prototype.propTypes = {
  currentTime: PropTypes.number.isRequired,
  duration: PropTypes.number.isRequired,
};

export function VideoPureComponent({
  i18n,
  ariaLabel,
  src,
  muteByDefault,
  className,
  classes,
  autoPlay,
  onVideoLoaded,
  iconColor,
  maxWidth,
  showTime,
  id,
  showPlay,
  customPlayObject,
}) {
  const videoElement = useRef(null);
  const [volumeVisible, setVolumeVisible] = useState(false);
  const [paused, setPaused] = useState(true);
  const [muted, setMuted] = useState(muteByDefault);
  const [ended, setEnded] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const iconClass = getIconClass(iconColor);

  useEffect(() => {
    if (!videoElement.current) return;
    videoElement.current.onplay = () => {
      setPaused(false);
      setEnded(false);
    };
    videoElement.current.onpause = () => {
      setPaused(true);
    };
    videoElement.current.onended = () => {
      setEnded(true);
    };
    videoElement.current.ontimeupdate = (event) => {
      setCurrentTime(event.target.currentTime);
    };
    videoElement.current.onloadeddata = (event) => {
      onVideoLoaded();
      setDuration(event.target.duration);
    };
  }, [videoElement, onVideoLoaded]);

  useEffect(() => {
    if (customPlayObject) {
      const { play } = customPlayObject;
      if (play) {
        videoElement.current.play();
      } else {
        videoElement.current.pause();
      }
    }
  }, [customPlayObject]);

  const onUserSlideProgress = (v) => {
    if (_.isFinite(v)) {
      videoElement.current.currentTime = v;
    }
    if (videoElement && videoElement.current.paused) {
      videoElement.current.play();
    }
  };

  const onVolumeClick = () => {
    setMuted(!muted);
  };

  const playIconName = useMemo(() => {
    if (ended) {
      return 'videoReplay';
    }

    return paused ? 'videoPlayBig' : 'videoPause';
  }, [ended, paused]);

  useEffect(() => {
    if (onVideoLoaded && _.get(videoElement, ['current', 'complete'], false)) {
      onVideoLoaded();
    }
  }, [onVideoLoaded, videoElement]);

  const width = maxWidth ? { width: maxWidth } : {};

  return (
    <div className={classnames('video-container', classes.videoContainer, className)} style={{ ...width }}>
      <video ref={videoElement} className={classes.previewVideo} aria-label={ariaLabel} muted={muted} autoPlay={autoPlay} onLoadedData={onVideoLoaded} id={id}>
        <source src={src} />
      </video>
      <div className={classnames(classes.root, 'video-previewer-root')}>
        <Fragment>
          <div className={classes.container}>
            {
              showPlay &&
              <IconButton
                className={iconClass}
                ariaLabel={paused ? i18n.getString(_TL_('Play')) : i18n.getString(_TL_('Pause'))}
                iconProps={{ iconName: playIconName }}
                onClick={() => (paused ? videoElement.current.play() : videoElement.current.pause())}
              />
            }
            {showTime && <Time currentTime={currentTime || 0} duration={duration || 0} />}
            <Slider
              className={classes.sliderContainer}
              min={0}
              max={_.get(videoElement, ['current', 'duration'], 0)}
              value={currentTime || 0}
              aria-label={i18n.getString(_TL_('Video progress'))}
              showValue={false}
              onChange={onUserSlideProgress}
            />
            <IconButton
              className={iconClass}
              ariaLabel={muted ? i18n.getString(_TL_('Unmute')) : i18n.getString(_TL_('Mute'))}
              iconProps={{ iconName: muted ? 'videoMute' : 'videoUnmute' }}
              onMouseOver={() => setVolumeVisible(!volumeVisible)}
              onFocus={() => setVolumeVisible(!volumeVisible)}
              onClick={onVolumeClick}
            />
          </div>
        </Fragment>
      </div>
    </div>
  );
}

VideoPureComponent.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    previewVideo: PropTypes.string,
    root: PropTypes.string,
    container: PropTypes.string,
    volumeIcon: PropTypes.string,
    volumeSlider: PropTypes.string,
    videoControlsShadow: PropTypes.string,
    sliderContainer: PropTypes.string,
    videoContainer: PropTypes.string,
  }).isRequired,
  ariaLabel: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
  className: PropTypes.string,
  muteByDefault: PropTypes.bool,
  autoPlay: PropTypes.bool,
  onVideoLoaded: PropTypes.func,
  iconColor: PropTypes.string,
  id: PropTypes.string,
  showTime: PropTypes.bool,
  maxWidth: PropTypes.number,
  showPlay: PropTypes.bool,
  customPlayObject: PropTypes.shape({
    play: PropTypes.bool,
  }),
};

VideoPureComponent.defaultProps = {
  className: '',
  showTime: false,
  muteByDefault: false,
  autoPlay: false,
  onVideoLoaded: _.noop,
  iconColor: 'white',
  id: '',
  maxWidth: 0,
  showPlay: true,
  customPlayObject: null,
};
